import { FleekError } from './FleekError';

type FolderAlreadyExistsErrorOptions = {
  folder: { parentFolderId: string | null; name: string };
};

export class FolderAlreadyExistsError extends FleekError<FolderAlreadyExistsErrorOptions> {
  public name = 'FolderAlreadyExistsError';

  toString = () =>
    `Folder ${this.data.folder.name} already exists in ${this.data.folder.parentFolderId ? 'parent' : 'root project'} folder.`;
}
